<template>
  <div class="DataTable">
    <div class="vld-parent">
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        :is-full-page="fullPage"
        color="#018389"
        loader="dots"
      ></loading>
    </div>
    <v-form ref="form" v-model="valid" lazy-validation>
      <div style="border-style: groove; border-width: 1px">
        <v-layout row wrap>
          <v-flex xs9 pa-2>
            <span v-if="this.kolicinaVina > 0"
              >Faza {{ this.faza_mark }} / Količina {{ this.kolicinaVina }}
              {{ this.jm_mark }}</span
            >
            <span v-else
              >Prazan tank / Kapacitet {{ this.preostalo_izabrani_tank }}
              {{ this.preostalo_izabrani_tank_jm }}</span
            >
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs3 pa-2>
            <!-- <v-select
            v-model="wine_select"
            :items="wine_items"
            item-value="id"
            :rules="[v => !!v || 'Obavezan podatak']"
            label="Vino"
            required
            persistent-hint
            return-object
            :disabled="disabled_vine"
          >
            <template
              slot="selection"
              slot-scope="data"
            >{{ data.item.year }} - {{ data.item.wineLabel.name }}</template>
            <template
              slot="item"
              slot-scope="data"
            >{{ data.item.year }} - {{ data.item.wineLabel.name }}</template>
          </v-select> -->

            <v-select
              v-model="wine_type_select"
              :items="wine_type_items"
              item-value="id"
              item-text="name"
              :rules="[(v) => !!v || 'Obavezan podatak']"
              label="Tip vina"
              required
              persistent-hint
              return-object
              :disabled="disabled_vine"
            >
            </v-select>
          </v-flex>
          <!--</v-layout>-->

          <v-flex xs3 pa-2>
            <v-autocomplete
              ref="element2"
              v-model="vineyard_grape_variety_select"
              :items="vineyard_grape_variety_items"
              item-text="name"
              item-value="id"
              :rules="[(v) => !!v || 'Obavezan podatak']"
              label="Grožđe"
              required
              persistent-hint
              return-object
              v-on:change="changeRoute"
              :disabled="!edit"
            ></v-autocomplete>
          </v-flex>

          <v-flex xs4 pa-2 v-if="!kupovno_grozdje">
            <v-select
              ref="element1"
              v-model="vineyard_select"
              :items="vineyard_items"
              item-value="vineyardId"
              item-text="vineyard"
              :rules="[(v) => !!v || 'Obavezan podatak']"
              label="Vinograd"
              required
              persistent-hint
              return-object
              :disabled="!edit"
              v-on:change="changeVineyardPom"
            ></v-select>
          </v-flex>
          <v-flex xs4 pa-2 v-else>
            <v-combobox
              ref="element1"
              v-model="vineyard_external_select"
              :items="vineyard_external_items"
              item-value="vineyardId"
              item-text="vineyard"
              :rules="[(v) => !!v || 'Obavezan podatak']"
              label="Vinograd"
              required
              persistent-hint
              return-object
              clearable
              @input.native="vineyard_external_select = $event.srcElement.value"
              :disabled="!edit"
            ></v-combobox>
          </v-flex>
          <v-flex
            xs1
            pa-2
            style="
              padding-top: 20px !important;
              padding-left: 0px !important;
              padding-top: 27px !important;
              max-width: 40px !important;
            "
            v-if="kupovno_grozdje"
            :disabled="!edit"
          >
          </v-flex>
          <v-flex
            xs1
            pa-2
            style="
              padding-top: 20px !important;
              padding-left: 0px !important;
              padding-top: 22px !important;
              max-width: 40px !important;
            "
            :disabled="!edit"
            v-else
          >
            <img
              data-v-68a7a11e=""
              @click="changeVineyard"
              title="Izbor berbe"
              src="../assets/menuIcons/grozdje.png"
              style="width: 32px; height: 32px; margin: 0 2px"
              v-if="this.vineyard_select !== undefined && edit"
            />
          </v-flex>

          <v-flex xs1 pa-2 style="padding-left: 0px !important">
            <v-checkbox
              label="Kupovno grožđe"
              v-model="kupovno_grozdje"
              :checked="kupovno_grozdje"
              @change="onCheckboxChange1"
              :disabled="!edit"
            ></v-checkbox>
          </v-flex>

          <!--<v-layout row wrap>-->
        </v-layout>
      </div>
    </v-form>
    <v-form ref="form_nevalidiraj" v-model="valid" lazy-validation>
      <v-layout row wrap>
        <v-flex xs2 pa-2>
          <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            max-width="290px"
            min-width="290px"
            :disabled="selected_berba.length > 0 || !edit"
          >
            <v-text-field
              slot="activator"
              v-model="dateFormatted"
              label="Berba"
              readonly
              :rules="[(v) => !!v || 'Obavezan podatak']"
              required
              @blur="date = parseDate(dateFormatted)"
              :disabled="selected_berba.length > 0 || !edit"
            ></v-text-field>
            <v-date-picker
              v-model="date"
              no-title
              @input="menu = false"
              :max="maxDate"
            ></v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex xs2 pa-2>
          <v-menu
            ref="entry_menu"
            v-model="entry_menu"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            max-width="290px"
            min-width="290px"
            :disabled="!edit"
          >
            <v-text-field
              slot="activator"
              v-model="entry_dateFormatted"
              label="Ulaz u tank"
              readonly
              :rules="[(v) => !!v || 'Obavezan podatak']"
              required
              @blur="entry_date = parseDate(entry_dateFormatted)"
              :disabled="!edit"
            ></v-text-field>
            <v-date-picker
              v-model="entry_date"
              no-title
              @input="entry_menu = false"
              :max="maxDate"
            ></v-date-picker>
          </v-menu>
        </v-flex>
        <!--</v-layout> &lt;!&ndash; /.Name &ndash;&gt;-->
        <v-flex xs2 pa-2>
          <v-menu
            ref="menu1"
            :close-on-content-click="false"
            v-model="menu1"
            :nudge-right="0"
            :return-value.sync="time"
            transition="scale-transition"
            lazy
            offset-y
            full-width
            min-width="290px"
            @input="
              (value) =>
                value && $refs.picker && ($refs.picker.selectingHour = true)
            "
            :disabled="!edit"
          >
            <v-text-field
              slot="activator"
              v-model="time"
              label="Vreme"
              readonly
              :rules="[(v) => !!v || 'Obavezan podatak']"
              required
              :disabled="!edit"
            ></v-text-field>
            <v-time-picker
              v-model="time"
              ref="picker"
              full-width
              landscape
              class="mt-3"
              format="24hr"
              :allowed-minutes="allowedStep"
              v-on:change="$refs.menu1.save(time)"
            >
              <v-spacer></v-spacer>
              <v-btn flat color="primary" @click="menu1 = false">Cancel</v-btn>
              <!-- <v-btn flat color="primary" @click="$refs.menu1.save(time)">OK</v-btn> -->
            </v-time-picker>
          </v-menu>
        </v-flex>

        <v-flex xs4 pa-2>
          <v-select
            ref="element3"
            v-model="faza"
            :items="faza_items"
            item-text="name"
            item-value="id"
            :rules="[(v) => !!v || 'Obavezan podatak']"
            label="Faza"
            required
            persistent-hint
            return-object
            lazy-validation
            :disabled="!edit"
          ></v-select>
        </v-flex>
        <v-flex xs2 pa-2 v-if="kupovno_grozdje">
          <v-text-field
            ref="element4"
            v-model="grape_price"
            label="Cena grožđa"
            type="number"
            :rules="[(v) => !!v || 'Obavezan podatak']"
            required
            :suffix="sufiks"
            @change="changeSufix($event)"
          ></v-text-field>
        </v-flex>

        <!--</v-layout> &lt;!&ndash; /.Name &ndash;&gt;-->

        <!--<v-layout row wrap>-->
      </v-layout>
    </v-form>
    <v-form ref="form1" v-model="valid" lazy-validation>
      <v-layout>
        <!--<v-layout row wrap>-->

        <v-flex xs2 pa-2>
          <v-text-field
            v-model="grape_quantity"
            label="Količina"
            type="number"
            :rules="[(v) => !!v || 'Obavezan podatak']"
            required
            :disabled="!edit"
          ></v-text-field>
        </v-flex>

        <v-flex xs1 pa-2>
          <v-select
            v-model="jm_grozdja_select"
            :items="jm_items"
            item-text="mark"
            item-value="id"
            :rules="[(v) => !!v || 'Obavezan podatak']"
            label="JM"
            required
            persistent-hint
            return-object
            :disabled="!edit"
          ></v-select>
        </v-flex>
        <v-flex xs2 pa-2>
          <v-text-field
            v-model="stum_quantity"
            :label="labelKljuk"
            type="number"
            :rules="[(v) => !!v || 'Obavezan podatak']"
            required
            :disabled="!edit"
          ></v-text-field>
        </v-flex>

        <v-flex xs1 pa-2>
          <v-select
            v-model="jm_sire_select"
            :items="jm_sire_items"
            item-text="mark"
            item-value="id"
            :rules="[(v) => !!v || 'Obavezan podatak']"
            label="JM"
            required
            persistent-hint
            return-object
            :disabled="!edit"
          ></v-select>
        </v-flex>

        <v-flex
          xs1
          pa-2
          v-if="tip_tanka === 'press'"
          style="padding-top: 25px !important"
        >
          <v-icon
            slot="activator"
            small
            class="ml-2"
            color="teal"
            title="Zapremina u litrima je samo orijentaciona."
            :disabled="!edit"
          >
            info
          </v-icon>
        </v-flex>
        <v-flex xs2 pa-2>
          <v-text-field
            ref="element_temperatura"
            v-model="stalk_quantity"
            label="Peteljki"
            type="number"
            suffix="kg"
            :disabled="!edit"
          ></v-text-field>
        </v-flex>
        <v-flex xs2 pa-2> </v-flex>
        <v-flex xs2 pa-2>
          <v-text-field
            v-model="maceracija_quantity"
            label="Maceracija"
            type="number"
          ></v-text-field>
        </v-flex>

        <v-flex xs1 pa-2>
          <v-select
            v-model="jm_maceracije_select"
            :items="jm_maceracije_items"
            item-text="mark"
            item-value="id"
            label="JM"
            persistent-hint
            return-object
          ></v-select>
        </v-flex>
      </v-layout>
    </v-form>
    <v-layout>
      <v-flex xs3 pa-2>
        <v-text-field
          ref="element_temperatura"
          v-model="temperatura_grozdja"
          label="Temp. grožđa"
          type="number"
        ></v-text-field>
      </v-flex>

      <v-flex xs2 pa-2>
        <v-select
          v-model="jm_temperature_select"
          :items="jm_temperature_items"
          item-text="mark"
          item-value="id"
          label="JM"
          persistent-hint
          return-object
          :disabled="true"
        ></v-select>
      </v-flex>
      <v-flex xs7 pa-2>
        <v-text-field
          ref="element_opis"
          v-model="opis"
          label="Opis"
        ></v-text-field>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12>
        <v-btn
          :disabled="!valid"
          @click="submit"
          class="AppButtonFilled"
          >Sačuvaj</v-btn
        >
        <v-btn
          @click="clear"
          class="AppButtonOutlined"
          >odustani</v-btn
        >
      </v-flex>
    </v-layout>

    <v-dialog
      v-model="dialogSpisakBerbi"
      scrollable
      content-class="ModalInModal"
      persistent
    >
      <v-container style="padding: 10px">
        <div class="DataTable">
          <v-form ref="form_modal" v-model="valid" lazy-validation>
            <v-layout>
              <v-flex xs11 pa-2 style="font-size: 20px !important">
                {{ this.naslovSpisakBerbi }}
              </v-flex>
              <v-flex xs1 pa-2>
                <a
                  class="closeModalInModalBtn"
                  @click.prevent="closeModalInModalStanjeBarika"
                >
                  <v-icon>close</v-icon>
                </a>
              </v-flex>
            </v-layout>

            <v-layout column>
              <v-flex style="overflow: hidden">
                <v-data-table
                  item-key="harvestId"
                  :headers="headers_modal_spisak_berbi"
                  :items="items_modal_spisak_berbi"
                  hide-actions
                  class="elevation-1"
                  :pagination.sync="pagination"
                  v-model="selected_berba_init"
                >
                  <template slot="headers" slot-scope="props_modal">
                    <tr>
                      <th
                        v-for="header in props_modal.headers"
                        :key="header.text"
                        :class="[
                          'column sortable',
                          pagination.descending ? 'desc' : 'asc',
                          header.value === pagination.sortBy ? 'active' : '',
                        ]"
                        @click="changeSort(header.value)"
                      >
                        <v-icon>arrow_upward</v-icon>
                        {{ header.text }}
                      </th>
                    </tr>
                  </template>
                  <template slot="items" slot-scope="props_modal">
                    <tr :active="props_modal.selected">
                      <td style="text-align: center; padding: 5px">
                        <v-checkbox
                          primary
                          hide-details
                          :input-value="props_modal.selected"
                          @click="changeSelect(props_modal.item)"
                        ></v-checkbox>
                        <!-- @click="props_modal.selected = !props_modal.selected" -->
                      </td>
                      <td style="display: none">
                        {{ props_modal.item.harvestId }}
                      </td>
                      <td style="text-align: center; padding: 5px">
                        {{ props_modal.item.vineyard.name }}
                      </td>
                      <td style="text-align: center; padding: 5px">
                        {{ props_modal.item.grapeVariety.name }}
                      </td>
                      <td style="text-align: center; padding: 0px">
                        {{ formatDateTime(props_modal.item.date) }}
                      </td>
                      <td style="text-align: center; padding: 5px">
                        {{
                          props_modal.item.quantity +
                          " " +
                          props_modal.item.unitOfMeasure.name
                        }}
                      </td>
                    </tr>
                  </template>
                  <template slot="no-data">
                    <v-alert
                      slot="no-results"
                      :value="true"
                      color="primary"
                      icon="info"
                      >Nema podataka.</v-alert
                    >
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12>
                <v-btn
                  :disabled="!valid || !edit"
                  @click="submit_modal"
                  class="AppButtonFilled"
                  >Sačuvaj</v-btn
                >
                <v-btn
                  @click="clear_modal"
                  class="AppButtonOutlined"
                  :disabled="!edit"
                  >odustani</v-btn
                >
              </v-flex>
            </v-layout>
          </v-form>
        </div>
      </v-container>
    </v-dialog>

    <TokenComponent ref="frmtoken" />
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

import { serverBus } from "../main";
import { readJSON } from "../helpers/Functions";
import TokenComponent from "../components/Token";

export default {
  name: "GrapeInputItem",
  components: {
    TokenComponent,
    Loading,
  },
  data: () => ({
    isLoading: false,
    loading: true,
    fullPage: true,

    valid: true,
    ID: 0,
    opis: "",
    wine_type_items: [],
    wine_select: undefined,
    wine_type_select: undefined,
    vineyard_grape_variety_items: [],
    jm_grozdja_select: "",
    jm_sire_select: "",
    jm_maceracije_select: "",
    jm_temperature_select: "",
    vineyard_grape_variety_select: undefined,
    date: null, //For datepicker
    menu: "",
    entry_date: null, //For datepicker
    entry_menu: "",
    grape_quantity: 0,
    grape_price: 0,
    stum_quantity_pom: 0,
    jm_items: [],
    stum_quantity: 0,
    maceracija_quantity: 0,
    temperatura_grozdja: undefined,
    jm_sire_items: [],
    jm_maceracije_items: [],
    jm_temperature_items: [],
    id_tank_phase_wine: 0,
    id_tank: 0,
    id_tank_phase_wine_blend: 0,
    preostalo_izabrani_tank: 0,
    tank_capacity: 0,
    vineyard_items: [],
    vineyard_external_items: [],
    faza_items: [],
    vineyard_select: undefined,
    vineyard_external_select: undefined,
    preostalo_izabrani_tank: 0,
    max_date: "",
    min_date: "",
    disabled_vine: false,
    time: undefined,
    menu1: "",
    faza_mark: "",
    jm_mark: "",
    kolicinaVina: 0,
    tip_vina_tank: 0,
    faza: undefined,

    date: null,
    dateFormatted: null,
    entry_dateFormatted: null,
    edit: true,
    kupovno_grozdje: false,
    tudji_vinograd: undefined,
    stalk_quantity: 0,
    init_eksterni_vinograd: 0,
    init_vinograd: 0,
    sufiks: "RSD",
    kolicinaVinaPom: 0,
    pagination: {
      sortBy: "id",
      rowsPerPage: 10000000,
    },
    headers_modal_spisak_berbi: [
      { text: "", value: "" },
      { text: "Vinograd", value: "vineyard.name" },
      { text: "Sorta", value: "grapeVariety.name" },
      { text: "Datum", value: "date" },
      { text: "Količina", value: "quantity" },
    ],
    items_modal_spisak_berbi: [],
    dialogSpisakBerbi: false,
    naslovSpisakBerbi: "Pregled berbi",
    selected_berba_init: [],
    selected_berba: [],
    tip_tanka: undefined,
    labelKljuk: "Kljuk",
    preostalo_izabrani_tank_jm: undefined,
    kolicinaGrozdjaSaBerbe: undefined,
  }),
  watch: {
    date(val) {
      this.dateFormatted = this.formatDate1(this.date);
    },
    entry_date(val) {
      this.entry_dateFormatted = this.formatDate1(this.entry_date);
    },
  },
  computed: {
    maxDate_input() {
      const today = new Date();
      // const dd = today.getUTCDate();
      return this.formatDate(today);
    },
    maxDate: {
      // getter
      get: function () {
        return this.max_date;
      },
      // setter
      set: function (newValue) {
        // alert(newValue);
        this.max_date = newValue;
      },
    },
    minDate: {
      // getter
      get: function () {
        return this.min_date;
      },
      // setter
      set: function (newValue) {
        this.min_date = newValue;
      },
    },
  },
  methods: {
    changeSelect(e) {
      

      this.selected_berba_init = [];
      this.selected_berba_init.push(e);
    },
    changeSufix(e) {
      this.sufiks = "RSD";
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
    formatDate1(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}.${month}.${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split(".");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    allowedStep: (m) => m % 5 === 0,
    formatDate(date) {
      let month = `${date.getMonth() + 1}`;
      let day = `${date.getDate()}`;
      const year = date.getFullYear();

      if (month.length < 2) month = `0${month}`;
      if (day.length < 2) day = `0${day}`;

      return [year, month, day].join("-");
    },
    setTime() {
      const today = new Date();
      let Minutes = `${today.getMinutes()}`;
      let Hours = `${today.getHours()}`;

      if (Hours.length < 2) Hours = `0${Hours}`;
      if (Minutes.length < 2) Minutes = `0${Minutes}`;

      this.time = [Hours, Minutes].join(":");
    },
    setDate() {
      const today = new Date();
      let Year = `${today.getFullYear()}`;
      let Month = `${today.getMonth() + 1}`;
      let Day = `${today.getDate()}`;

      if (Month.length < 2) Month = `0${Month}`;
      if (Day.length < 2) Day = `0${Day}`;

      this.date = [Year, Month, Day].join("-");
      this.entry_date = [Year, Month, Day].join("-");
    },
    formatTime(time) {
      let HH = time.split(":")[0];
      let mm = time.split(":")[1];

      return HH + ":" + mm;
    },
    onCheckboxChange1(newValue) {
      this.kolicinaGrozdjaSaBerbe = undefined;
      this.selected_berba = [];

      if (newValue) {
        setTimeout(() => {
          let inputEl = this.$refs.element4.$el.querySelector("input");
          inputEl.select();
        }, 200);
      }
    },
    changeRoute(a) {
      // pobrisati sve osim id_prostorije
      this.selected_berba = [];

      this.vineyard_items = [];
      this.vineyard_external_items = [];

      if (typeof a !== "undefined") {
        if (a.description !== undefined) {
          this.vineyard_external_select = undefined;
          this.vineyard_select = undefined;
        }

        this.getAllVinograde(a.id);
        this.getAllVinogradeExternal(a.id);
      }
    },
    formatDateTime(date) {
      let answer = "";

      if (date !== null && typeof date !== "undefined") {
        let lokDate = date.split("T")[0];
        let lokTime = date.split("T")[1];

        let month = lokDate.split("-")[1];
        let day = lokDate.split("-")[2];
        const year = lokDate.split("-")[0];

        let HH = lokTime.split(":")[0];
        let mm = lokTime.split(":")[1];

        answer = [day, month, year].join(".") + " " + [HH, mm].join(":");
      }

      return answer;
    },
    changeVineyard() {
      this.dialogSpisakBerbi = true;

      this.selected_berba = [];
      this.kolicinaGrozdjaSaBerbe = undefined;

      this.getAllSifarnikSpisakBerbi();
    },
    changeVineyardPom(e) {
      if (e !== undefined)
        if (e.vineyardGrapeVarietyId !== undefined) {
          this.selected_berba_init = this.selected_berba;
          this.kolicinaGrozdjaSaBerbe = undefined;
        }
    },
    closeModalInModalStanjeBarika() {
      

      this.selected_berba = this.selected_berba_init;
      this.items_modal_spisak_berbi = [];
      this.selected_berba_init = [];

      this.dialogSpisakBerbi = false;

      if (this.selected_berba.length > 0)
        if (
          this.selected_berba[0].date !== undefined &&
          this.selected_berba[0].date !== null
        ) {
          this.date = this.selected_berba[0].date.split("T")[0];
          this.kolicinaGrozdjaSaBerbe = this.selected_berba[0].quantity;

          // this.grape_quantity = this.selected_berba[0].quantity;
          // this.jm_grozdja_select = this.selected_berba[0].unitOfMeasure;
        }
    },
    changeInputDate(a) {
      this.max_date = a;

      this.$refs.entry_menu.save(a);
    },
    changeDate(a) {
      this.min_date = a;

      this.$refs.menu.save(a);
    },
    getAllSifarnikSpisakBerbi() {
      this.$http
        .get(
          this.globalServiceLocation +
            this.globalPort +
            "/vineyard_operation_execution/grape_harvested/" +
            this.vineyard_select.vineyardId +
            "/" +
            this.vineyard_grape_variety_select.id,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          console.log(response.data);

          this.items_modal_spisak_berbi = response.data;
        })
        .catch((e) => {
          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/vineyard_operation_execution/grape_harvested/" +
                        this.vineyard_select.vineyardId +
                        "/" +
                        this.vineyard_grape_variety_select.id,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      this.items_modal_spisak_berbi = response.data;
                    })
                    .catch((e) => {
                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    proveriBerbu() {
      let odgovor = false;

      // if(this.kolicinaGrozdjaSaBerbe !== undefined)
      //   if (Number(this.grape_quantity) > Number(this.kolicinaGrozdjaSaBerbe))
      //     odgovor = true;

      return odgovor;
    },
    newSifarnik() {
      if (this.jm_grozdja_select !== undefined) {
        let preostalo_izabrani_tank = Number(this.preostalo_izabrani_tank);
        let stum_quantity = Number(this.stum_quantity);
        let stalk_quantity = Number(this.stalk_quantity);
        let grape_quantity = Number(this.grape_quantity);
        let maceracija_quantity = Number(this.maceracija_quantity);
        let temperatura_grozdja = Number(this.temperatura_grozdja);
        let grape_price = Number(this.grape_price);

        if (this.proveriBerbu())
          {
            this.isLoading = false;
            alert("Količina grožđa je veća od količine sa izabrane berbe.");
          }
        else if (stum_quantity === 0 || grape_quantity === 0){
          this.isLoading = false;
          alert("Količina vina i kljuka/šire mora biti veća od 0.");
        }
        else {
          if (this.date > this.entry_date){
            this.isLoading = false;
          
            alert(
              "Datum berbe mora biti manji ili jednak datumu ulaza grožđa u tank."
            );
          }
          else {
            var complexObjectTank = {
              id: this.id_tank,
            };

            var complexObjectPhase;

            if (typeof this.faza.id !== "undefined")
              complexObjectPhase = {
                id: this.faza.id,
              };
            else
              complexObjectPhase = {
                id: this.faza,
              };

            var pom_wine_type_to_select = "";

            if (typeof this.wine_type_select !== "undefined")
              if (typeof this.wine_type_select.id !== "undefined")
                if (this.wine_type_select.id == null)
                  pom_wine_type_to_select = this.wine_type_select;
                else pom_wine_type_to_select = this.wine_type_select.id;
              else pom_wine_type_to_select = this.wine_type_select;

            var pom_jm_to_select;

            if (
              typeof this.jm_maceracije_select !== "undefined" &&
              this.jm_maceracije_select !== ""
            ) {
              if (typeof this.jm_maceracije_select.id === "undefined")
                pom_jm_to_select = this.jm_maceracije_select;
              else pom_jm_to_select = this.jm_maceracije_select.id;
            }

            var complexObjectVineyard;

            if (this.kupovno_grozdje) {
              if (this.vineyard_external_select.vineyardId === undefined)
                complexObjectVineyard = {
                  id: null,
                  name: this.vineyard_external_select,
                };
              else
                complexObjectVineyard = {
                  id: this.vineyard_external_select.vineyardId,
                };
            } else {
              let vineyardID;

              if (this.vineyard_select.vineyardId !== undefined)
                vineyardID = this.vineyard_select.vineyardId;
              else vineyardID = this.vineyard_select;

              complexObjectVineyard = {
                id: vineyardID,
              };
            }

            var complexObjectVineyardGrapeVariety = {
              grapeVariety: {
                id: this.vineyard_grape_variety_select.id,
              },
              vineyard: complexObjectVineyard,
            };

            var complexObjectUnitOfMeasureGrape = {
              id: this.jm_grozdja_select.id,
            };

            var complexObjectUnitOfMeasureMust = {
              id: this.jm_sire_select.id,
            };

            var complexObjectUnitOfTemperatura = {
              id: this.jm_temperature_select,
            };

            var complexObjectGrapeInput;

            if (this.selected_berba.length === 0) {
              if (this.kupovno_grozdje)
                complexObjectGrapeInput = {
                  vineyardGrapeVariety: complexObjectVineyardGrapeVariety,
                  harvestDate: this.date,
                  entryDate: this.entry_date + "T" + this.time,
                  grapeQuantity: this.grape_quantity,
                  stumQuantity: this.stum_quantity,
                  stalkQuantity: this.stalk_quantity,
                  description: this.opis,
                  unitOfMeasureGrapeQuantity: complexObjectUnitOfMeasureGrape,
                  unitOfMeasureMustQuantity: complexObjectUnitOfMeasureMust,
                  grapeTemperature: this.temperatura_grozdja,
                  unitOfMeasureTemperature: complexObjectUnitOfTemperatura,
                  isPurchased: this.kupovno_grozdje,
                  grapePrice: grape_price,
                };
              else
                complexObjectGrapeInput = {
                  vineyardGrapeVariety: complexObjectVineyardGrapeVariety,
                  harvestDate: this.date,
                  entryDate: this.entry_date + "T" + this.time,
                  grapeQuantity: this.grape_quantity,
                  stumQuantity: this.stum_quantity,
                  stalkQuantity: this.stalk_quantity,
                  description: this.opis,
                  unitOfMeasureGrapeQuantity: complexObjectUnitOfMeasureGrape,
                  unitOfMeasureMustQuantity: complexObjectUnitOfMeasureMust,
                  grapeTemperature: this.temperatura_grozdja,
                  unitOfMeasureTemperature: complexObjectUnitOfTemperatura,
                  isPurchased: this.kupovno_grozdje,
                };
            } else {
              complexObjectGrapeInput = {
                harvestDate: this.date,
                entryDate: this.entry_date + "T" + this.time,
                grapeQuantity: this.grape_quantity,
                stumQuantity: this.stum_quantity,
                stalkQuantity: this.stalk_quantity,
                description: this.opis,
                unitOfMeasureGrapeQuantity: complexObjectUnitOfMeasureGrape,
                unitOfMeasureMustQuantity: complexObjectUnitOfMeasureMust,
                grapeTemperature: this.temperatura_grozdja,
                unitOfMeasureTemperature: complexObjectUnitOfTemperatura,
                isPurchased: this.kupovno_grozdje,
                vineyardOperationHarvest: {
                  id: this.selected_berba[0].harvestId,
                },
              };
            }

            var complexObjectTankPhaseWineBlend;

            if (
              this.maceracija_quantity === "" ||
              typeof this.maceracija_quantity === "undefined"
            )
              complexObjectTankPhaseWineBlend = [
                {
                  grapeInput: complexObjectGrapeInput,
                },
              ];
            else if (typeof pom_jm_to_select === "undefined")
              complexObjectTankPhaseWineBlend = [
                {
                  grapeInput: complexObjectGrapeInput,
                  maceration: this.maceracija_quantity,
                },
              ];
            else
              complexObjectTankPhaseWineBlend = [
                {
                  grapeInput: complexObjectGrapeInput,
                  maceration: this.maceracija_quantity,
                  macerationUnitOfMeasure: { id: pom_jm_to_select },
                },
              ];
            var url = "";

            if (this.id_tank_phase_wine == 0) {
              var complexObjectWine;
              complexObjectWine = {
                wineLabel: {
                  wineType: {
                    id: pom_wine_type_to_select,
                  },
                },
              };

              url =
                this.globalServiceLocation +
                this.globalPort +
                "/tank_phase_wine/first_insert_grape_input";

              var complexObject = {
                tank: complexObjectTank,
                phase: complexObjectPhase,
                wine: complexObjectWine,
                tankPhaseWineBlend: complexObjectTankPhaseWineBlend,
              };
            } else {
              var complexObjectWine;

              var pom_wine_select;

              if (
                typeof this.wine_select !== "undefined" &&
                this.wine_select !== ""
              ) {
                if (typeof this.wine_select.id === "undefined")
                  pom_wine_select = this.wine_select;
                else pom_wine_select = this.wine_select.id;
              }

              complexObjectWine = {
                id: pom_wine_select,
              };

              url =
                this.globalServiceLocation +
                this.globalPort +
                "/tank_phase_wine/other_insert_grape_input";

              var complexObject = {
                id: this.id_tank_phase_wine,
                tank: complexObjectTank,
                phase: complexObjectPhase,
                wine: complexObjectWine,
                tankPhaseWineBlend: complexObjectTankPhaseWineBlend,
              };
            }

            this.$http
              .post(url, complexObject, {
                headers: {
                  "Content-Type": "application/json",
                  Authorization:
                    "Bearer  " + localStorage.getItem("user-token"),
                },
              })
              .then((response) => {
                this.isLoading = false;

                if (Number(this.id_tank_phase_wine) === 0) {
                  this.id_tank_phase_wine = response.data.id;
                  this.kolicinaVina = response.data.quantity;
                  this.faza_mark = response.data.phase.phaseMark;
                  this.jm_mark = response.data.quantityUnitOfMeasure.mark;
                  this.wine_select = response.data.wine.id;

                  let item = document.getElementById("naslov").innerText;
                  document.getElementById("naslov").innerText =
                    item + " / " + response.data.wine.wineLabel.name;
                }

                this.PreostaloUTanku(this.id_tank);

                // alert(this.id_tank_phase_wine);

                serverBus.$emit("refresh_grape_input", this.id_tank_phase_wine);

                this.tip_vina_tank = Number(pom_wine_type_to_select);

                this.disabled_vine = true;

                this.clear();
              })
              .catch((e) => {
                // // console.log(e.response);

                if (!e.response) {
                  this.isLoading = false;

                  alert(
                    this.$t("error.message")
                  );
                } else {
                  if (e.response.status === 401) {
                    this.$refs.frmtoken
                      .osvezavanjeTokena(
                        localStorage.getItem("user-refresh-token")
                      )
                      .then((result) => {
                        // // console.log(result);
                        // // console.log("Novi token - " + localStorage.getItem("user-token"));

                        this.$http
                          .post(url, complexObject, {
                            headers: {
                              "Content-Type": "application/json",
                              Authorization:
                                "Bearer  " + localStorage.getItem("user-token"),
                            },
                          })
                          .then((response) => {
                            this.isLoading = false;

                            if (Number(this.id_tank_phase_wine) === 0) {
                              this.id_tank_phase_wine = response.data.id;
                              this.kolicinaVina = response.data.quantity;
                              this.faza_mark = response.data.phase.phaseMark;
                              this.jm_mark =
                                response.data.quantityUnitOfMeasure.mark;
                              this.wine_select = response.data.wine.id;

                              let item =
                                document.getElementById("naslov").innerText;
                              document.getElementById("naslov").innerText =
                                item +
                                " / " +
                                response.data.wine.wineLabel.name;
                            }

                            this.PreostaloUTanku(this.id_tank);

                            // alert(this.id_tank_phase_wine);

                            serverBus.$emit(
                              "refresh_grape_input",
                              this.id_tank_phase_wine
                            );

                            this.tip_vina_tank = Number(
                              pom_wine_type_to_select
                            );

                            this.disabled_vine = true;

                            this.clear();
                          })
                          .catch((e) => {
                            this.isLoading = false;

                            let pomError = readJSON(e.response.data.message);
                            alert(pomError);
                          });
                      });
                  } else {
                    this.isLoading = false;

                    let pomError = readJSON(e.response.data.message);
                    alert(pomError);
                  }
                }
              });
          }
        }
      }
    },
    changeSifarnik() {
      let preostalo_izabrani_tank = Number(
        this.preostalo_izabrani_tank + this.stum_quantity_pom
      );
      let stum_quantity = Number(this.stum_quantity);
      let stalk_quantity = Number(this.stalk_quantity);
      let grape_quantity = Number(this.grape_quantity);
      let grape_price = Number(this.grape_price);

      if (this.proveriBerbu()){
        this.isLoading = false;
        alert("Količina grožđa je veća od količine sa izabrane berbe.");
      }
      else if (stum_quantity === 0 || grape_quantity === 0){
        this.isLoading = false;
        alert("Količina vina i kljuka/šire mora biti veća od 0.");
      }
      else if (this.date > this.entry_date){
        this.isLoading = false;
        alert(
          "Datum berbe mora biti manji ili jednak datumu ulaza grožđa u tank."
        );
      }
      else {
        var complexObjectTank = {
          id: this.id_tank,
        };

        var complexObjectPhase;

        if (typeof this.faza.id !== "undefined")
          complexObjectPhase = {
            id: this.faza.id,
          };
        else
          complexObjectPhase = {
            id: this.faza,
          };

        var pom_wine_to_select = "";

        if (typeof this.wine_type_select !== "undefined")
          if (typeof this.wine_type_select.id !== "undefined")
            if (this.wine_type_select.id == null)
              pom_wine_to_select = this.wine_type_select;
            else pom_wine_to_select = this.wine_type_select.id;
          else pom_wine_to_select = this.wine_type_select;

        var complexObjectWine;

        complexObjectWine = {
          id: pom_wine_to_select,
        };

        var complexObjectVineyardGrapeVariety;

        if (this.vineyard_grape_variety_select.id == null)
          complexObjectVineyardGrapeVariety = {
            id: this.vineyard_grape_variety_select,
          };
        else
          complexObjectVineyardGrapeVariety = {
            id: this.vineyard_grape_variety_select.id,
          };

        var complexObjectUnitOfMeasureGrape;

        if (this.jm_grozdja_select.id == null)
          complexObjectUnitOfMeasureGrape = {
            id: this.jm_grozdja_select,
          };
        else
          complexObjectUnitOfMeasureGrape = {
            id: this.jm_grozdja_select.id,
          };

        var complexObjectUnitOfMeasureMust;

        if (this.jm_sire_select.id == null)
          complexObjectUnitOfMeasureMust = {
            id: this.jm_sire_select,
          };
        else
          complexObjectUnitOfMeasureMust = {
            id: this.jm_sire_select.id,
          };

        var complexObjectUnitOfTemperatura = {
          id: this.jm_temperature_select,
        };

        ///////// Postavljanje objekta complexObjectVineyard ///////////////
        var complexObjectVineyard;

        if (this.kupovno_grozdje) {
          if (this.vineyard_external_select.vineyardId === undefined)
            complexObjectVineyard = {
              id: null,
              name: this.vineyard_external_select,
            };
          else
            complexObjectVineyard = {
              id: this.vineyard_external_select.vineyardId,
            };
        } else {
          let vineyardID;

          if (this.vineyard_select.vineyardId !== undefined)
            vineyardID = this.vineyard_select.vineyardId;
          else vineyardID = this.vineyard_select;

          complexObjectVineyard = {
            id: vineyardID,
          };
        }
        ////////////////////////////////////////////////////////

        ///////// Postavljanje objekta complexObjectVineyardGrapeVariety ///////////////
        var complexObjectVineyardGrapeVariety;

        if (this.kupovno_grozdje) {
          if (this.vineyard_external_select.vineyardId === undefined)
            complexObjectVineyardGrapeVariety = {
              grapeVariety: {
                id: this.vineyard_grape_variety_select.id,
              },
              vineyard: complexObjectVineyard,
            };
          else if (
            this.init_eksterni_vinograd !==
            this.vineyard_external_select.vineyardId
          )
            complexObjectVineyardGrapeVariety = {
              grapeVariety: {
                id: this.vineyard_grape_variety_select.id,
              },
              vineyard: complexObjectVineyard,
            };
          else {
            var indeks = this.vineyard_external_items.findIndex(
              (x) => x.vineyardId === this.vineyard_external_select.vineyardId
            );

            complexObjectVineyardGrapeVariety = {
              id: this.vineyard_external_items[indeks].vineyardGrapeVarietyId,
            };
          }
        } else {
          var indeks = this.vineyard_items.findIndex(
            (x) => x.vineyardId === this.vineyard_select.vineyardId
          );

          complexObjectVineyardGrapeVariety = {
            id: this.vineyard_items[indeks].vineyardGrapeVarietyId,
          };
        }

        var complexObjectGrapeInput;

        if (this.selected_berba.length === 0) {
          if (this.kupovno_grozdje)
            complexObjectGrapeInput = {
              id: this.ID,
              vineyardGrapeVariety: complexObjectVineyardGrapeVariety,
              harvestDate: this.date,
              entryDate: this.entry_date + "T" + this.time,
              grapeQuantity: this.grape_quantity,
              stumQuantity: this.stum_quantity,
              stalkQuantity: this.stalk_quantity,
              description: this.opis,
              unitOfMeasureGrapeQuantity: complexObjectUnitOfMeasureGrape,
              unitOfMeasureMustQuantity: complexObjectUnitOfMeasureMust,
              grapeTemperature: this.temperatura_grozdja,
              unitOfMeasureTemperature: complexObjectUnitOfTemperatura,
              isPurchased: this.kupovno_grozdje,
              grapePrice: grape_price,
            };
          else
            complexObjectGrapeInput = {
              id: this.ID,
              vineyardGrapeVariety: complexObjectVineyardGrapeVariety,
              harvestDate: this.date,
              entryDate: this.entry_date + "T" + this.time,
              grapeQuantity: this.grape_quantity,
              stumQuantity: this.stum_quantity,
              stalkQuantity: this.stalk_quantity,
              description: this.opis,
              unitOfMeasureGrapeQuantity: complexObjectUnitOfMeasureGrape,
              unitOfMeasureMustQuantity: complexObjectUnitOfMeasureMust,
              grapeTemperature: this.temperatura_grozdja,
              unitOfMeasureTemperature: complexObjectUnitOfTemperatura,
              isPurchased: this.kupovno_grozdje,
            };
        } else {
          complexObjectGrapeInput = {
            id: this.ID,
            harvestDate: this.date,
            entryDate: this.entry_date + "T" + this.time,
            grapeQuantity: this.grape_quantity,
            stumQuantity: this.stum_quantity,
            stalkQuantity: this.stalk_quantity,
            description: this.opis,
            unitOfMeasureGrapeQuantity: complexObjectUnitOfMeasureGrape,
            unitOfMeasureMustQuantity: complexObjectUnitOfMeasureMust,
            grapeTemperature: this.temperatura_grozdja,
            unitOfMeasureTemperature: complexObjectUnitOfTemperatura,
            isPurchased: this.kupovno_grozdje,
            vineyardOperationHarvest: {
              id: this.selected_berba[0].harvestId,
            },
          };
        }

        var pom_jm_to_select;

        if (
          typeof this.jm_maceracije_select !== "undefined" &&
          this.jm_maceracije_select !== ""
        ) {
          if (typeof this.jm_maceracije_select.id === "undefined")
            pom_jm_to_select = this.jm_maceracije_select;
          else pom_jm_to_select = this.jm_maceracije_select.id;
        }
        var complexObjectTankPhaseWineBlend;

        if (
          this.maceracija_quantity === "" ||
          typeof this.maceracija_quantity === "undefined"
        )
          complexObjectTankPhaseWineBlend = [
            {
              id: this.id_tank_phase_wine_blend,
              tankPhaseWineId: this.id_tank_phase_wine,
              grapeInput: complexObjectGrapeInput,
            },
          ];
        else if (typeof pom_jm_to_select === "undefined")
          complexObjectTankPhaseWineBlend = [
            {
              id: this.id_tank_phase_wine_blend,
              tankPhaseWineId: this.id_tank_phase_wine,
              grapeInput: complexObjectGrapeInput,
              maceration: this.maceracija_quantity,
            },
          ];
        else
          complexObjectTankPhaseWineBlend = [
            {
              id: this.id_tank_phase_wine_blend,
              tankPhaseWineId: this.id_tank_phase_wine,
              grapeInput: complexObjectGrapeInput,
              maceration: this.maceracija_quantity,
              macerationUnitOfMeasure: {
                id: pom_jm_to_select,
              },
            },
          ];

        var complexObject = {
          id: this.id_tank_phase_wine,
          tank: complexObjectTank,
          phase: complexObjectPhase,
          wine: complexObjectWine,
          tankPhaseWineBlend: complexObjectTankPhaseWineBlend,
        };

        this.$http
          .put(
            this.globalServiceLocation +
              this.globalPort +
              "/tank_phase_wine/update_grape_input",
            complexObject,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer  " + localStorage.getItem("user-token"),
              },
            }
          )
          .then((response) => {
            this.isLoading = false;

            this.PreostaloUTanku(this.id_tank);

            serverBus.$emit("refresh_grape_input", this.id_tank_phase_wine);

            this.tip_vina_tank = Number(pom_wine_to_select);

            // // console.log(response);

            // this.faza_mark = response.data.phase.phaseMark;

            this.clear();
          })
          .catch((e) => {
            // // console.log(e.response);

            if (!e.response) {
              this.isLoading = false;

              alert(
                this.$t("error.message")
              );
            } else {
              if (e.response.status === 401) {
                this.$refs.frmtoken
                  .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                  .then((result) => {
                    // // console.log(result);
                    // // console.log("Novi token - " + localStorage.getItem("user-token"));

                    this.$http
                      .put(
                        this.globalServiceLocation +
                          this.globalPort +
                          "/tank_phase_wine/update_grape_input",
                        complexObject,
                        {
                          headers: {
                            "Content-Type": "application/json",
                            Authorization:
                              "Bearer  " + localStorage.getItem("user-token"),
                          },
                        }
                      )
                      .then((response) => {
                        this.isLoading = false;

                        this.PreostaloUTanku(this.id_tank);

                        serverBus.$emit(
                          "refresh_grape_input",
                          this.id_tank_phase_wine
                        );

                        this.tip_vina_tank = Number(pom_wine_to_select);

                        // // console.log(response);

                        // this.faza_mark = response.data.phase.phaseMark;

                        this.clear();
                      })
                      .catch((e) => {
                        this.isLoading = false;

                        let pomError = readJSON(e.response.data.message);
                        alert(pomError);
                      });
                  });
              } else {
                this.isLoading = false;

                let pomError = readJSON(e.response.data.message);
                alert(pomError);
              }
            }
          });
      }
    },
    getAllTipoviVina() {
      this.$http
        .get(this.globalServiceLocation + this.globalPort + "/wine_type/all", {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer  " + localStorage.getItem("user-token"),
          },
        })
        .then((response) => {
          // // console.log(response.data);

          this.wine_type_items = response.data;

          if (Number(this.tip_vina_tank) !== 0)
            this.wine_type_select = Number(this.tip_vina_tank);
          else {
            this.wine_type_select = undefined;
          }
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/wine_type/all",
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      // // console.log(response.data);

                      this.wine_type_items = response.data;

                      if (Number(this.tip_vina_tank) !== 0)
                        this.wine_type_select = Number(this.tip_vina_tank);
                      else {
                        this.wine_type_select = undefined;
                      }
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    getAllFaze() {
      this.$http
        .get(
          this.globalServiceLocation +
            this.globalPort +
            "/phase/for_grape_input",
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          // // console.log(response.data);
          let _this = this;
          this.faza_items = response.data;

          let pomFaza;

          response.data.forEach(function (entry) {
            if (entry.phaseMark === _this.faza_mark) pomFaza = entry;
          });

          this.faza = pomFaza;
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/phase/for_grape_input",
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      let _this = this;
                      this.faza_items = response.data;

                      let pomFaza;

                      response.data.forEach(function (entry) {
                        if (entry.phaseMark === _this.faza_mark)
                          pomFaza = entry;
                      });

                      this.faza = pomFaza;
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    getAllVinograde(id) {
      if (typeof id !== "undefined")
        this.$http
          .get(
            this.globalServiceLocation +
              this.globalPort +
              "/vineyard_grape_variety/vineyard/grape_variety/" +
              id +
              "/external/false",
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer  " + localStorage.getItem("user-token"),
              },
            }
          )
          .then((response) => {
            // // console.log(response.data);

            this.vineyard_items = response.data;
            // this.vineyard_select = undefined;
          })
          .catch((e) => {
            // // console.log(e.response);

            if (!e.response) {
              alert(
                this.$t("error.message")
              );
            } else {
              if (e.response.status === 401) {
                this.$refs.frmtoken
                  .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                  .then((result) => {
                    // // console.log(result);
                    // // console.log("Novi token - " + localStorage.getItem("user-token"));

                    his.$http
                      .get(
                        this.globalServiceLocation +
                          this.globalPort +
                          "/vineyard_grape_variety/vineyard/grape_variety/" +
                          id +
                          "/external/false",
                        {
                          headers: {
                            "Content-Type": "application/json",
                            Authorization:
                              "Bearer  " + localStorage.getItem("user-token"),
                          },
                        }
                      )
                      .then((response) => {
                        // // console.log(response.data);

                        this.vineyard_items = response.data;
                        // this.vineyard_select = undefined;
                      })
                      .catch((e) => {
                        // // console.log(e.response);

                        let pomError = readJSON(e.response.data.message);
                        alert(pomError);
                      });
                  });
              } else {
                let pomError = readJSON(e.response.data.message);
                alert(pomError);
              }
            }
          });
    },
    getAllVinogradeExternal(id) {
      if (typeof id !== "undefined")
        this.$http
          .get(
            this.globalServiceLocation +
              this.globalPort +
              "/vineyard_grape_variety/vineyard/grape_variety/" +
              id +
              "/external/true",
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer  " + localStorage.getItem("user-token"),
              },
            }
          )
          .then((response) => {
            // // console.log(response.data);

            this.vineyard_external_items = response.data;
            // this.vineyard_external_select = undefined;
          })
          .catch((e) => {
            // // console.log(e.response);

            if (!e.response) {
              alert(
                this.$t("error.message")
              );
            } else {
              if (e.response.status === 401) {
                this.$refs.frmtoken
                  .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                  .then((result) => {
                    // // console.log(result);
                    // // console.log("Novi token - " + localStorage.getItem("user-token"));

                    his.$http
                      .get(
                        this.globalServiceLocation +
                          this.globalPort +
                          "/vineyard_grape_variety/vineyard/grape_variety/" +
                          id +
                          "/external/true",
                        {
                          headers: {
                            "Content-Type": "application/json",
                            Authorization:
                              "Bearer  " + localStorage.getItem("user-token"),
                          },
                        }
                      )
                      .then((response) => {
                        // // console.log(response.data);

                        this.vineyard_external_items = response.data;
                        // this.vineyard_external_select = undefined;
                      })
                      .catch((e) => {
                        // // console.log(e.response);

                        let pomError = readJSON(e.response.data.message);
                        alert(pomError);
                      });
                  });
              } else {
                let pomError = readJSON(e.response.data.message);
                alert(pomError);
              }
            }
          });
    },
    getAllSorteGrozdja() {
      this.$http
        .get(
          this.globalServiceLocation + this.globalPort + "/grape_variety/all",
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          // // console.log(response.data);

          this.vineyard_grape_variety_items = response.data;
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  his.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/grape_variety/all",
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      // // console.log(response.data);

                      this.vineyard_grape_variety_items = response.data;
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    submit_modal() {
      this.selected_berba = this.selected_berba_init;

      this.closeModalInModalStanjeBarika();
    },
    clear_modal() {
      this.selected_berba = [];

      this.kolicinaGrozdjaSaBerbe = undefined;
    },
    submit() {
      if (this.$refs.form.validate() && this.$refs.form1.validate()) {
        if (this.$refs.element3.validate()) {
          this.isLoading = true;

          setTimeout(() => {
            if (this.ID != "" && Number(this.ID) != 0) this.changeSifarnik();
            else this.newSifarnik();

            // this.isLoading = false;
          }, 1000);
        } else {
          this.faza = null;
      }
      }
    },
    clear() {
      // this.$refs.form.reset();
      this.setTime();
      this.setDate();

      this.$refs.form1.reset();
      this.$refs.element3.reset();

      this.$refs.element1.reset();
      this.$refs.element2.reset();

      this.$refs.element_temperatura.reset();
      this.$refs.element_opis.reset();

      this.ID = 0;
      this.kupovno_grozdje = false;

      this.vineyard_items = [];

      this.grape_price = 0;

      this.selected_berba = [];
      this.selected_berba_init = [];

      this.kolicinaGrozdjaSaBerbe = undefined;
    },
    PreostaloUTanku(idTank) {
      if (typeof idTank !== "undefined" && typeof idTank !== "object" && idTank !== 0)
        this.$http
          .get(
            this.globalServiceLocation +
              this.globalPort +
              "/tank/" +
              idTank +
              "/free_space",
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer  " + localStorage.getItem("user-token"),
              },
            }
          )
          .then((response) => {
            // // console.log(idTank);

            this.preostalo_izabrani_tank = response.data.freeSpaceInTank;
            this.preostalo_izabrani_tank_jm = response.data.unitOfMeasure.mark;
            this.tank_capacity = response.data.tankCapacity;
            this.kolicinaVina =
              response.data.tankCapacity - response.data.freeSpaceInTank;
          })
          .catch((e) => {
            // // console.log(e.response);

            if (!e.response) {
              alert(
                this.$t("error.message")
              );
            } else {
              if (e.response.status === 401) {
                this.$refs.frmtoken
                  .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                  .then((result) => {
                    // // console.log(result);
                    // // console.log("Novi token - " + localStorage.getItem("user-token"));

                    this.$http
                      .get(
                        this.globalServiceLocation +
                          this.globalPort +
                          "/tank/" +
                          idTank +
                          "/free_space",
                        {
                          headers: {
                            "Content-Type": "application/json",
                            Authorization:
                              "Bearer  " + localStorage.getItem("user-token"),
                          },
                        }
                      )
                      .then((response) => {
                        // // console.log(idTank);

                        this.preostalo_izabrani_tank =
                          response.data.freeSpaceInTank;
                        this.tank_capacity = response.data.tankCapacity;
                        this.kolicinaVina =
                          response.data.tankCapacity -
                          response.data.freeSpaceInTank;
                      })
                      .catch((e) => {
                        // // console.log(e.response);

                        let pomError = readJSON(e.response.data.message);
                        alert(pomError);
                      });
                  });
              } else {
                let pomError = readJSON(e.response.data.message);
                alert(pomError);
              }
            }
          });
    },
    getAllJediniceMere() {
      this.$http
        .get(
          this.globalServiceLocation +
            this.globalPort +
            "/unit_of_measure/group/2",
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          // // console.log(response.data);
          this.jm_items = [];
          let _this = this;
          let kilogram;

          response.data.forEach(function (entry) {
            if (entry.mark !== "g") _this.jm_items.push(entry);

            if (entry.mark === "kg") kilogram = entry;
          });

          this.jm_grozdja_select = kilogram;
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/unit_of_measure/group/2",
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      this.jm_items = [];
                      let _this = this;
                      let kilogram;

                      response.data.forEach(function (entry) {
                        if (entry.mark !== "g") _this.jm_items.push(entry);

                        if (entry.mark === "kg") kilogram = entry;
                      });

                      this.jm_grozdja_select = kilogram;
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    getAllJediniceMereSira() {
      this.$http
        .get(
          this.globalServiceLocation +
            this.globalPort +
            "/unit_of_measure/group/1",
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          // // console.log(response.data);
          let niz = [];
          let litar;

          response.data.forEach(function (entry) {
            if (entry.mark !== "ml") niz.push(entry);

            if (entry.mark === "l") litar = entry;
          });

          this.jm_sire_items = niz;
          this.jm_sire_select = litar;
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/unit_of_measure/group/1",
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      let niz = [];
                      let litar;

                      response.data.forEach(function (entry) {
                        if (entry.mark !== "ml") niz.push(entry);

                        if (entry.mark === "l") litar = entry;
                      });

                      this.jm_sire_items = niz;
                      this.jm_sire_select = litar;
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    getAllJediniceMereMaceracija() {
      this.$http
        .get(
          this.globalServiceLocation +
            this.globalPort +
            "/unit_of_measure/group/11",
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          // // console.log(response.data);

          this.jm_maceracije_items = response.data;
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/unit_of_measure/group/11",
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      // // console.log(response.data);

                      this.jm_maceracije_items = response.data;
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    getAllJediniceMereTemperatura() {
      this.$http
        .get(
          this.globalServiceLocation +
            this.globalPort +
            "/unit_of_measure/group/6",
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          // // console.log(response.data);

          this.jm_temperature_items = response.data;
          this.jm_temperature_select = 16;
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/unit_of_measure/group/11",
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      // // console.log(response.data);

                      this.jm_temperature_items = response.data;
                      this.jm_temperature_select = 16;
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
  },
  mounted() {
    this.clear();
    // this.setTime();
    // this.setDate();

    this.getAllTipoviVina();
    this.getAllVinograde(0);
    this.getAllVinogradeExternal(0);
    this.getAllSorteGrozdja();

    this.getAllJediniceMere();
    this.getAllJediniceMereSira();
    this.getAllJediniceMereMaceracija();
    this.getAllJediniceMereTemperatura();

    this.getAllFaze();

    const today = new Date();
    this.max_date = this.formatDate(today);

    serverBus.$on("refresh_header", (kolicina, prazan) => {
      this.kolicinaVina = Number(this.kolicinaVina) - Number(kolicina);
      this.kolicinaVinaPom = Number(this.kolicinaVina);

      this.clear();

      if (prazan) this.id_tank_phase_wine = 0;
    });

    serverBus.$on("applied_grape_input", (item) => {
      // console.log(item);

      this.id_tank_phase_wine_blend = item.tankPhaseWineBlendId;
      this.ID = item.grapeInputDto.id;

      this.wine_select = item.wineId;

      console.log(this.vineyard_grape_variety_items);

      this.vineyard_grape_variety_select =
        item.grapeInputDto.vineyardGrapeVariety.grapeVariety;

      this.getAllVinograde(
        item.grapeInputDto.vineyardGrapeVariety.grapeVariety.id,
        true
      );

      this.getAllVinogradeExternal(
        item.grapeInputDto.vineyardGrapeVariety.grapeVariety.id,
        true
      );

      this.kupovno_grozdje = item.grapeInputDto.isPurchased;
      this.grape_price = Number(item.grapeInputDto.grapePrice);

      if (item.grapeInputDto.isPurchased) {
        this.init_eksterni_vinograd =
          item.grapeInputDto.vineyardGrapeVariety.vineyard.id;

        var pomObj = {
          vineyardId: item.grapeInputDto.vineyardGrapeVariety.vineyard.id,
          vineyard: item.grapeInputDto.vineyardGrapeVariety.vineyard.name,
        };

        this.vineyard_external_select = pomObj;
      } else {
        this.init_vinograd =
          item.grapeInputDto.vineyardGrapeVariety.vineyard.id;

        var pomObj = {
          vineyardId: item.grapeInputDto.vineyardGrapeVariety.vineyard.id,
          vineyard: item.grapeInputDto.vineyardGrapeVariety.vineyard.name,
        };

        this.vineyard_select = pomObj;
      }

      this.PreostaloUTanku(this.id_tank);

      this.date = item.grapeInputDto.harvestDate.split("T")[0];
      // this.entry_date = item.grapeInputDto.entryDate;
      this.entry_date = item.grapeInputDto.entryDate.split("T")[0];
      this.time = this.formatTime(item.grapeInputDto.entryDate.split("T")[1]);

      this.grape_quantity = item.grapeInputDto.grapeQuantity;
      this.jm_grozdja_select = item.grapeInputDto.unitOfMeasureGrapeQuantity.id;

      this.maceracija_quantity = item.maceration;

      if (item.macerationUnitOfMeasure !== null)
        if (typeof item.macerationUnitOfMeasure.id !== undefined)
          this.jm_maceracije_select = item.macerationUnitOfMeasure.id;
        else this.jm_maceracije_select = undefined;
      else this.jm_maceracije_select = undefined;

      this.stum_quantity = item.grapeInputDto.stumQuantity;
      this.stum_quantity_pom = item.grapeInputDto.stumQuantity;
      this.stalk_quantity = item.grapeInputDto.stalkQuantity;

      this.jm_sire_select = item.grapeInputDto.unitOfMeasureMustQuantity.id;

      this.opis = item.grapeInputDto.description;

      if (item.grapeInputDto.id === 0) this.disabled_vine = false;
      else this.disabled_vine = true;

      this.faza = item.phaseId;

      this.temperatura_grozdja = item.grapeInputDto.grapeTemperature;
      this.jm_temperature_select = 16;

      if (
        item.grapeInputDto.vineyardOperationHarvest !== null &&
        item.grapeInputDto.vineyardOperationHarvest !== undefined
      ) {
        let el1 = {
          harvestId: item.grapeInputDto.vineyardOperationHarvest.id,
        };

        this.selected_berba_init = [];
        this.selected_berba_init.push(el1);

        this.selected_berba = [];
        this.selected_berba.push(el1);
      }

      this.wine_type_select = item.wineTypeId;
    });

    serverBus.$on(
      "grape_input",
      (
        id_tank_phase_wine,
        id_tank,
        wine_id,
        kolicina_vina,
        faza_mark,
        jm_mark,
        faza,
        tip_vina,
        edit,
        tip_tanka
      ) => {
        // alert('grape_input');
        this.tip_tanka = tip_tanka;

        if (tip_tanka === "press") this.labelKljuk = "Kljuka";
        else this.labelKljuk = "Kljuk";

        this.id_tank_phase_wine = id_tank_phase_wine;
        this.id_tank = id_tank;

        this.PreostaloUTanku(id_tank);

        if (Number(id_tank_phase_wine) === 0) this.disabled_vine = false;
        else this.disabled_vine = true;

        this.kolicinaVina = kolicina_vina;
        this.faza_mark = faza_mark;
        this.jm_mark = jm_mark;

        if (typeof edit !== "undefined") this.edit = edit;
        else this.edit = true;

        if (Number(tip_vina) !== 0) {
          this.tip_vina_tank = Number(tip_vina);
          this.wine_type_select = Number(tip_vina);
        }
        if (Number(wine_id) !== 0) {
          this.wine_select = Number(wine_id);
        }
      }
    );
  },
};
</script>

<style lang="scss" scoped>
.grapeInputItemComponentForm {
  max-width: 430px;
}

.Description textarea {
  height: 40px;
}

div.v-input.Description.v-textarea.v-text-field {
  margin-top: 0px;
}

div.flex.pa-2 {
  padding-bottom: 0px !important;
  padding-top: 0px !important;
}

#FloatingButton {
  // position: absolute;
  width: 25px;
  height: 25px;
  font-size: 25px;

  background-color: #018389;
  background-image: url("../assets/menuIcons/grozdje.png");
  background-position: center;

  &:active,
  &:focus {
    box-shadow: none;
  }
}
</style>
